import {
  LOAD_RESERVATION_REVIEW_FOR_ADMIN,
  UPDATE_SQUAD_QTY_FOR_ADMIN,
  UPDATE_CART_TOTAL_FOR_ADMIN,
  UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN,
  DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN,
  PROCESSING_STARTED,
  PROCESSING_FINISHED
} from './constants';

export const loadReservationReview = cart => ({
  type: LOAD_RESERVATION_REVIEW_FOR_ADMIN,
  payload: cart
});

export const updateSquadQuantity = squad => ({
  type: UPDATE_SQUAD_QTY_FOR_ADMIN,
  payload: squad
});

export const updateVirtualEventQuantity = virtualEvent => ({
  type: UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN,
  payload: virtualEvent
});

export const updateCartTotal = () => ({
  type: UPDATE_CART_TOTAL_FOR_ADMIN
});

export const displayClearCartConfirmation = showModal => ({
  type: DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN,
  payload: showModal
});

export const processingStarted = () => ({
  type: PROCESSING_STARTED
});

export const processingFinished = () => ({
  type: PROCESSING_FINISHED
});



// WEBPACK FOOTER //
// ./src/features/admin/review/actionTypes.js